(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["landing-creator-02-videos"] && !Shopify.designMode) return;
  try {
    
/* §02 / §07 UGC video strip — marquee sizing and hover/tap playback.
   Scoped entirely to [data-td-ls02]; touches nothing else on the page. */
(function () {
  var SECTION = '[data-td-ls02]';

  /* The track must stay wider than one group PLUS the viewport, otherwise the
     right-hand edge runs out of cards before the loop wraps and a strip of bare
     background shows. Two groups is only enough while one group is wider than
     the screen; at 1920 a 1484px group leaves a 436px hole for a quarter of every
     cycle. So the copy count is computed from the measured widths. */
  function requiredCopies(root) {
    var group = root.querySelector('[data-td-ls02-group]');
    var viewport = root.querySelector('[data-td-ls02-viewport]');
    if (!group || !viewport) return 0;
    var groupW = group.getBoundingClientRect().width;
    var viewW = viewport.getBoundingClientRect().width;
    if (!groupW) return 0;
    return { copies: Math.max(2, Math.ceil(viewW / groupW) + 1), groupW: groupW };
  }

  function buildTrack(root) {
    var clone = root.querySelector('[data-td-ls02-clone]');
    var group = root.querySelector('[data-td-ls02-group]');
    if (!clone || !group) return;

    var need = requiredCopies(root);
    if (!need) return;

    // Rebuild only when the geometry actually changes, so a resize does not
    // restart the animation and jump the strip for no reason.
    if (root.tdCopies === need.copies && root.tdGroupW === need.groupW) return;
    root.tdCopies = need.copies;
    root.tdGroupW = need.groupW;

    clone.innerHTML = '';
    for (var c = 0; c < need.copies - 1; c++) {
      /* Duplicated cards keep their <video>, because on a wide screen most of
         what a visitor can hover IS a duplicate. They are kept out of the
         accessibility tree and the tab order instead: the clone container is
         aria-hidden and every control inside it is removed from tab order. */
      Array.prototype.forEach.call(group.children, function (card) {
        var copy = card.cloneNode(true);
        copy.removeAttribute('data-td-ls02-card');
        copy.setAttribute('data-td-ls02-ghost', '');
        Array.prototype.forEach.call(copy.querySelectorAll('button'), function (btn) {
          btn.setAttribute('tabindex', '-1');
        });
        clone.appendChild(copy);
      });
    }

    root.style.setProperty('--td-ls02-shift', need.groupW + 'px');
  }

  function init(root) {
    if (root.dataset.tdLs02Ready === 'true') return;
    root.dataset.tdLs02Ready = 'true';

    var isMarquee = root.dataset.marquee === 'true';
    var pauseWhileActive = root.dataset.pauseActive === 'true';
    var hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    var active = null;

    if (isMarquee) {
      buildTrack(root);
      var resizeTimer = null;
      window.addEventListener('resize', function () {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () { buildTrack(root); }, 150);
      });
    }

    function setMarqueePaused(paused) {
      if (!isMarquee || !pauseWhileActive) return;
      root.setAttribute('data-paused', paused ? 'true' : 'false');
    }

    /* The <video> ships with no src at all — the URL waits on a data attribute
       until the card is invoked, so the page downloads zero video bytes on load
       no matter how a browser interprets preload="none". */
    function attachSource(video) {
      if (video.getAttribute('src')) return;
      var url = video.getAttribute('data-td-ls02-src');
      if (!url) return;
      video.setAttribute('src', url);
      video.load();
    }

    function mountEmbed(card) {
      if (card.querySelector('.td-ls02__frame')) return;
      var id = card.getAttribute('data-yt-id');
      var host = card.getAttribute('data-yt-host');
      if (!id) return;
      var src =
        host === 'vimeo'
          ? 'https://player.vimeo.com/video/' + id + '?autoplay=1&muted=1&title=0&byline=0'
          : 'https://www.youtube.com/embed/' + id +
            '?autoplay=1&mute=1&playsinline=1&rel=0&modestbranding=1';
      var frame = document.createElement('iframe');
      frame.className = 'td-ls02__frame';
      frame.setAttribute('src', src);
      frame.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture');
      frame.setAttribute('allowfullscreen', '');
      frame.setAttribute('title', card.getAttribute('data-yt-title') || 'Video');
      card.appendChild(frame);
    }

    function unmountEmbed(card) {
      var frame = card.querySelector('.td-ls02__frame');
      if (frame) frame.remove();
    }

    function deactivate() {
      if (!active) return;
      var card = active;
      active = null;
      card.classList.remove('is-active');
      root.classList.remove('td-ls02--has-active');
      var trigger = card.querySelector('[data-td-ls02-trigger]');
      if (trigger) trigger.setAttribute('aria-pressed', 'false');
      var video = card.querySelector('[data-td-ls02-video]');
      if (video) {
        video.pause();
        // Muted again so the next card never starts with sound unexpectedly.
        video.muted = true;
        var sound = card.querySelector('[data-td-ls02-sound]');
        if (sound) sound.setAttribute('aria-pressed', 'false');
      }
      unmountEmbed(card);
      setMarqueePaused(false);
    }

    function activate(card) {
      if (active === card) return;
      deactivate();
      active = card;
      card.classList.add('is-active');
      root.classList.add('td-ls02--has-active');
      var trigger = card.querySelector('[data-td-ls02-trigger]');
      if (trigger) trigger.setAttribute('aria-pressed', 'true');

      var video = card.querySelector('[data-td-ls02-video]');
      if (video) {
        video.muted = true;
        attachSource(video);
        // Play once from wherever it stopped; `ended` rewinds it for next time.
        var attempt = video.play();
        if (attempt && typeof attempt.catch === 'function') {
          attempt.catch(function () {
            /* preload="none" means the first invocation can be refused because
               there is nothing buffered yet. Load, then try once more — but only
               if this card is still the active one by the time data arrives. */
            var retry = function () {
              video.removeEventListener('loadeddata', retry);
              if (active !== card) return;
              var second = video.play();
              if (second && typeof second.catch === 'function') {
                second.catch(function () { /* refused; the poster stays up */ });
              }
            };
            if (video.readyState >= 2) {
              // Already has data, so `loadeddata` would never fire again.
              retry();
            } else {
              video.addEventListener('loadeddata', retry);
              video.load();
            }
          });
        }
      } else if (card.getAttribute('data-kind') === 'youtube') {
        mountEmbed(card);
      }
      setMarqueePaused(true);
    }

    function cardOf(node) {
      return node && node.closest ? node.closest('.td-ls02__card') : null;
    }

    /* Delegated so duplicated cards behave identically and cards added by a
       later buildTrack() need no rebinding. */
    if (hoverCapable) {
      root.addEventListener('mouseover', function (event) {
        var card = cardOf(event.target);
        if (!card || !card.querySelector('[data-td-ls02-trigger]')) return;
        activate(card);
      });
      root.addEventListener('mouseout', function (event) {
        var card = cardOf(event.target);
        if (!card || card !== active) return;
        if (event.relatedTarget && card.contains(event.relatedTarget)) return;
        deactivate();
      });
    }

    root.addEventListener('click', function (event) {
      var sound = event.target.closest ? event.target.closest('[data-td-ls02-sound]') : null;
      if (sound) {
        event.preventDefault();
        event.stopPropagation();
        var card = cardOf(sound);
        var video = card && card.querySelector('[data-td-ls02-video]');
        if (!video) return;
        video.muted = !video.muted;
        sound.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
        sound.setAttribute('aria-label', video.muted ? 'Turn sound on' : 'Turn sound off');
        return;
      }

      var trigger = event.target.closest ? event.target.closest('[data-td-ls02-trigger]') : null;
      if (!trigger) return;
      event.preventDefault();
      var target = cardOf(trigger);
      if (!target) return;
      // Tapping the active card turns it off; tapping another hands over.
      if (target === active) deactivate();
      else activate(target);
    });

    // Rewind so a finished card plays from the start next time it is invoked.
    root.addEventListener(
      'ended',
      function (event) {
        if (event.target && event.target.matches('[data-td-ls02-video]')) {
          event.target.currentTime = 0;
        }
      },
      true
    );

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) deactivate();
    });
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll(SECTION);
    Array.prototype.forEach.call(roots, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
